// Consts
export const BORDER_RADIUS = '4px';
export const EXTRA_SPACE = '8px';
export const BREAKPOINT = 768;
export const BREAKPOINT_XGA = 1024;
export const BREAKPOINT_LG = 1440;
export const BREAKPOINT_HD_PLUS = 1650;
export const BREAKPOINT_FULL_HD = 1920;
export const MEDIA_QUERY = `(max-width: ${BREAKPOINT}px)`;
export const RETINA_RESOLUTION = '2dppx';
export const CAPTURE_MAX_HEIGHT = 171;
export const DESCRIPTION_MAX_HEIGHT = 142;
export const DESCRIPTION_MAX_SYMBOLS = 310;
export const LABEL_FONT = '12px';
export const INPUT_FONT = '14px';
export const INPUT_HEIGHT = 35;
export const INPUT_PADDING = '8px';
export const INPUT_BORDER = {
  width: '1px',
  style: 'solid',
};

export const COLORS = {
  blueBrighten: '#0085ba',
  bluePrimary: '#5476a4',
  flaglerDarkBlue: '#0077A6',
  sectionTitleFont: '#2a5690',
  blueDark: '#3b557a',
  blueMedium: '#316cba',
  blueAccent: '#1eb7eb',
  cloudyBlue: '#bcc3d0',
  grayBluish: '#f4f6f9',
  cyanBluishGray: '#b8bfc3',
  lightGray: '#e5e5e5',
  grayDark: '#26414a',
  orange: '#ffa716',
  peach: '#ffc37d',
  orangeCoral: '#fef7f0',
  orangeSquash: '#f6a623',
  orangeRed: '#f87f5c',
  white: '#ffffff',
  sanMarino: 'rgba(84,118,164,0.1)', // bluePrimary 0.1
  darkSlateBlue: 'rgba(28, 84, 102, 0.75)',
  lightTurquoise: 'rgba(127,235,185,0.17)',
  stormyBlue: 'rgba(84, 118, 164)',
  fontLight: '#4a4a4a',
  fontLighter: '#60757C',
  fontPrimary: '#326cba',
  fontRegular: '#264149',
  orangePink: '#ff7159',
  alert: '#fff8f1',
  black: '#000',
  greenLime: '#2ad69b',
  blueGrayish: '#eef2f9',
  blueAccentPlus: '#0fc0fc',
};

// Const Styles
export const NOTIFICATION_ICON = {
  HEALTH_ALERT: 'health-alert',
  UPCOMING_SURVEY: 'up-surveys',
  ASSIGN_TO_PROGRAM: 'program',
  REMOVE_FROM_PROGRAM: 'program',
  AUTO_RESPONSE: 'survey-result',
  ANSWERED_SURVEY: 'survey-result',
};

export const PROFILE_MENU_ICON = {
  BACK: 'back-healthboard',
  PROVIDER_INF0: 'provider-info',
  DETAILED_PROFILE: 'member',
  PATIENT_INFO: 'patient-info',
  PATIENT_HEALTHBOARD: 'programs',
  DATA: 'data',
  CIRCLE_OF_CARE: 'circle-of-care',
  PROGRAM: 'program-2',
  PROFILE_SETTINGS: 'settings',
  PROFILE_PAYMENT_METHODS: 'payment-methods',
  PROFILE_DOCUMENTATION: 'doc',
  SUPPORT: 'support',
};

export const THEMES = {
  FLAGLER: 'flagler',
};

export const FONT_FAMILY = {
  primary: "'Nunito Sans', Helvetica, Arial, sans-serif",
  secondary: 'NunitoSans-Regular',
};



// WEBPACK FOOTER //
// ./src/constants/styles.js